import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import cn from 'classnames';

import styles from './styles.m.scss';

import NavDropdown from './NavDropdown';
import { routes } from '../../routes';
import magic from '../../util/magic';

const mapStore = ({ user }) => ({ user });

const NavBar = ({ user }) => {
  const nonTrainingRegistrations = user.latestRegistrations.filter(
    (r) => r.status != magic.complete && r.trainingId == null,
  );
  const registrations = user.latestRegistrations.filter((r) => r.status != magic.complete);

  return (
    <nav className={cn(styles.tabs, 'row', 'mb-5', 'd-print-none')}>
      <div className="nav nav-tabs" id="dashboard-nav-tab" role="tablist">
        <NavLink exact to={routes.dashboard} className="nav-item nav-link">
          Dashboard
        </NavLink>
        <NavDropdown baseUrl={routes.certificationsAndTraining.root} title="Certifications & Training">
          <Link to={routes.certificationsAndTraining.register.root} className="dropdown-item">
            Register
          </Link>
          {nonTrainingRegistrations.length > 0 && (
            <Link to={routes.certificationsAndTraining.experience.root} className="dropdown-item">
              Experience Hours
            </Link>
          )}
          {(registrations.length > 0 || user.userCertifications.length > 0) && (
            <Link to={routes.certificationsAndTraining.extension.root} className="dropdown-item">
              Extensions
            </Link>
          )}
          {user.userCertifications.length > 0 && (
            <Link to={routes.certificationsAndTraining.certifications.root} className="dropdown-item">
              My Certifications
            </Link>
          )}
          {user.userTrainings.length > 0 && (
            <Link to={routes.certificationsAndTraining.trainings.root} className="dropdown-item">
              My Trainings
            </Link>
          )}
        </NavDropdown>
      </div>
    </nav>
  );
};

export default connect(mapStore)(NavBar);
